import { all, compose, filter, groupBy, ifElse, isNil, map, pluck, props, reject, sort, take } from 'ramda';

import { toIsoDateFormat } from 'utils';

import { SEARCH_TYPE } from './constants';

const isTaskColumnsEmpty = (columns) => (task) => Math.max(...reject(isNil, props(columns, task))) === 0;
const hasNonEmptyTask = (columns) => (task) => Math.max(...reject(isNil, props(columns, task))) > 0;

export const filterByEmptyColumns = (columns) => filter(hasNonEmptyTask(columns));

export const groupByUsername = groupBy((task) => task.username);

export const mapEmptyValues = (columns) =>
	map((task) => {
		if (isTaskColumnsEmpty(columns)(task)) {
			return {
				username: task.username,
				solverName: task.solverName,
				taskTypeId: -1,
				taskCountBeforeDeadline: '-',
				taskCountAfterDeadline: '-',
				taskCountAfterNotification: '-',
			};
		} else {
			return task;
		}
	});

const isTaskEmpty = (task) => task.taskTypeId === -1;
// if there are only empty tasks, reduce to one
// otherwise, reduce task list to non empty tasks
const keepOneEmptyTaskIfNoNonEmpty = ifElse(all(isTaskEmpty), take(1), reject(isTaskEmpty));

export const removeUnnecessaryValues = map(keepOneEmptyTaskIfNoNonEmpty);

export const requestFactory = (formData, allSellers) => {
	const { statType, seller } = formData;

	const body = {
		statisticsType: { type: statType },
		usernames: seller
			? [seller]
			: compose(
					sort((a, b) => a - b),
					pluck('login'),
			  )(allSellers),
	};

	if (statType === SEARCH_TYPE.success) {
		body.filterFrom = toIsoDateFormat(formData.dateFrom);
		body.filterUntil = toIsoDateFormat(formData.dateTo);
	}

	return body;
};
